export default "https://cdn-static.gokick.com/assets/510b01776e4307c2b342e37a2ed4ce502ef69aad/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";